import styled from "styled-components";
import theme from "../../shared/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 7.5px;
  margin-right: 7.5px;
  margin-bottom: 15px;
`;

export const Label = styled.label`
  color: ${theme.colors.defaultLabel};
  font-weight: bold;
  font-size: ${theme.font.fontSizeDefault};
  ${props => props.isError && `color: ${theme.colors.error}`}
  font-family: Open Sans,sans-serif!important;
`;

export const InputStyle = styled.input`
  -webkit-box-shadow: inset 0 1px 2px hsla(0, 0%, 4%, 0.1);
  box-shadow: inset 0 1px 2px hsla(0, 0%, 4%, 0.1);
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  border: solid 1px #33393d;
  padding-left: 10px;
  color: #363636;
  font-family: Open Sans,sans-serif;
  height: 33px;
  ${props =>
    props.isError &&
    `border-color: ${theme.colors.error}; background-color: ${theme.colors.lightError};`}
`;
